import { UserSolidIconComponent } from 'components/svgIcons/UserSolid';
import { containsChild } from 'common/helpers/HtmlElementHelper';
import React, { useState, useRef, Suspense, lazy } from 'react';


const menuId = "user-menu-options";
const UserMenuListComponent = lazy(() => import(
    /* webpackChunkName: "user-menu-list" */
    './components/MenuList'));


export function UserMenuComponent() {
    const [open, setOpenState] = useState(false);
    const mainElRef = useRef(null);

    function subscribeEvents() {
        document.addEventListener('mousedown', blur, false);
    };

    function unSubscribeEvents() {
        document.removeEventListener('mousedown', blur, false);
    };

    function openMenu() {
        subscribeEvents();
        setOpenState(true);
    };

    function closeMenu() {
        unSubscribeEvents();
        setOpenState(false);
    };

    function blur({ target }) {
        const { value: isChild } = containsChild({
            target: mainElRef.current,
            child: target
        });

        if(isChild) {
            return;
        };

        return closeMenu();
    };

    function toggle() {
        return open ? closeMenu() : openMenu();
    };

    return (
        <section className="user-menu" ref={mainElRef}>
            <button
                title='Opções do utilizador'
                className='user-avatar-btn'
                aria-controls={menuId}
                aria-expanded={open}
                onClick={evt => toggle(!open)}
            >
                <UserSolidIconComponent />
            </button>

            {!open ? (
                <div id={menuId} className='dropdown-options' style={{ display: open ? 'block' : 'none' }} />
            ) : (
                <Suspense>
                    <UserMenuListComponent id={menuId} open={open} />
                </Suspense>
            )}
        </section>
    );
};